import store from 'src/store';
import { userDataSel } from 'src/store/modules/user';

export const powerUser = 'POWER_USER';
export const superUser = 'SUPER_USER';
export const viewInvoices = 'VIEW_INVOICES';
export const manageSubUsers = 'ADMIN_SUBUSERS';

export const isSpecialUser = (): boolean => {
  const state = store.getState();
  return (
    userDataSel(state).permission.includes(powerUser) ||
    userDataSel(state).permission.includes(superUser)
  );
};

export const isPowerUser = (): boolean => {
  const state = store.getState();
  return userDataSel(state).permission.includes(powerUser);
};

export const isSuperUser = (): boolean => {
  const state = store.getState();
  return userDataSel(state).permission.includes(superUser);
};

export const canViewInvoices = (): boolean => {
  const state = store.getState();
  return userDataSel(state).permission.includes(viewInvoices);
};

export const canManageSubUsers = (): boolean => {
  const state = store.getState();
  return userDataSel(state).permission.includes(manageSubUsers);
};
